import React, { Component } from "react";
import ControversiaCurpComponent from "../../../components/personaReferencia/controversiaCurp/ControversiaCurpComponent";
import { controversiaCurpStore } from "./ControversiaCurp.store";
import { controversiaCurpDispatcher } from "./ControversiaCurp.dispatcher";
import { ReduxConnect } from "../../../../toolkit/decorators/Artifact";
import ModalFrame from "../../../../toolkit/modalFrame";

interface Props {
  idPersonaCurp: number;
  idPersonaSolicitante?: number;
  isOpen: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

interface State {}

@ReduxConnect(controversiaCurpStore, controversiaCurpDispatcher)
export default class ControversiaCurpModal extends Component<Props, State> {
  state = {};

  render() {
    return (
      <ModalFrame
        title={"Liberación de Curp"}
        isOpen={this.props.isOpen}
        toggle={this.props.onClose}
        size="lg"
      >
        <ControversiaCurpComponent {...(this.props as any)} />
      </ModalFrame>
    );
  }
}
